import {useRef, useEffect, useLayoutEffect} from 'react';

export const useTimeout = (callback: () => void, delay: number | null) => {
  const savedCallback = useRef(callback);

  useLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!delay) {
      return;
    }

    function tick() {
      savedCallback.current?.();
    }

    const id = setTimeout(tick, delay);
    return () => clearTimeout(id);
  }, [delay]);
};
